// Import from React Project
import image_1 from "./../../../../assets/img/slider/1.jpg";
import image_3 from "./../../../../assets/img/slider/3.jpg";
import image_4 from "./../../../../assets/img/slider/4.jpg";

//Export to Image Fade Slider
export const images = [image_1, image_3, image_4];
export const alt_text = "slider - drukarnia jelenia góra #";
